var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5979 8.18747L10.3251 4.57637C10.1208 4.47454 9.8793 4.47454 9.67421 4.57637L2.40146 8.18747C2.256 8.25897 2.144 8.38463 2.07782 8.52113C2.03418 8.60924 2 8.75947 2 8.83313V12.9967C2 13.3947 2.32582 13.7189 2.72728 13.7189C3.12873 13.7189 3.45455 13.3947 3.45455 12.9967V9.90057L4.9091 10.4783V14.0201C4.9091 14.2931 5.06474 14.543 5.31128 14.6658C6.56147 15.2854 7.84656 16.0517 10 16.0517C12.1535 16.0517 13.4393 15.2854 14.6888 14.6658C14.9353 14.5423 15.091 14.2931 15.091 14.0194V10.4776L17.5433 9.50335C17.8088 9.39791 17.9877 9.1473 17.9993 8.86274C18.0117 8.57891 17.8539 8.3153 17.5979 8.18747ZM13.6364 13.5731L12.9273 13.9248C11.0938 14.8355 8.90548 14.8355 7.07274 13.9248L6.36365 13.5731V11.0561L9.72948 12.3937C9.81675 12.4283 9.90839 12.4442 10 12.4442C10.0917 12.4442 10.1833 12.4283 10.2706 12.3929L13.6364 11.0554V13.5731ZM10 10.9442L4.5011 8.75947L10 6.0302L15.499 8.75947L10 10.9442Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72728 14.6094C2.32582 14.6094 2 14.9329 2 15.3316V16.776C2 17.1754 2.32582 17.4982 2.72728 17.4982C3.12873 17.4982 3.45455 17.1754 3.45455 16.776V15.3316C3.45455 14.9329 3.12873 14.6094 2.72728 14.6094Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon);
export default __webpack_public_path__ + "static/media/EducationIcon.4c3760c370548fe70d33537b10eb0c3e.svg";
export { ForwardRef as ReactComponent };